import React, { Component } from 'react';
import { Card, Flex, Box, Heading, Text, Button } from 'rebass';
import styled from 'styled-components';
import withSession from '../../lib/withSession';
import ConfirmModal from '../../components/ConfirmModal';
import { Mutation, Query } from 'react-apollo';
import { ADVERTISE_SMS_LOGIN, CHANGE_MEDICATION_CONSENT, REJECT_SMS_LOGIN } from '../../graphql';
import { withRouter } from 'react-router-dom';
import { useState } from 'react';
import Modal from 'styled-react-modal';
import { ActivateSmsLoginFeature } from '../smsLogin/ActivateSmsLoginFeature';

const CardBox = styled(Card)`
  width: 100%;
  padding: 32px;
`;
const InfoBox = styled(Flex)`
  flex: 1;
  background: ${(props) => props.theme.color.information};
  border-radius: 10px;
  padding: 25px;
  color: ${(props) => props.theme.color.darkBlue};
  justify-content: center;
`;

const ModalInner = styled(Box)`
  max-width: 600px;
  width: 100%;
`;

const Circle = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 1px;
  border-style: solid;
  border-radius: 50%;
  align-self: center;
  background-color: ${(props) => props.theme.color.white};
  width: ${(props) => props.theme.px(2)};
  height: ${(props) => props.theme.px(2)};
  margin-right: ${(props) => props.theme.px(1)};
`;

const Label = styled.label`
  position: relative;
  display: flex;
  cursor: pointer;
  overflow: hidden;
  align-self: center;
  color: ${(props) => props.color || props.theme.color.greyDark};
`;

const styles = {
  focus: {
    Circle: {
      borderColor(props) {
        if (props.disabled) {
          return `0 0 0 1px ${props.theme.color.grey}`;
        }
        if (props.error) {
          return `0 0 0 1px ${props.theme.color.red}`;
        }
        return `0 0 0 1px ${props.theme.color.primary}`;
      },
    },
  },
  checked: {
    Circle: {
      backgroundColor(props) {
        if (props.disabled) {
          return props.theme.color.grey;
        }
        if (props.error) {
          return props.theme.color.red;
        }
        return props.theme.color.primary;
      },
    },
  },
  Circle: {
    borderColor(props) {
      if (props.disabled) {
        return props.theme.color.greyLight;
      }
      if (props.error) {
        return props.theme.color.red;
      }
      return props.theme.color.greyLight;
    },
  },
};

const InputStyled = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  clipPath: inset(1px 0 0 0);
  border: 0;
  visibility: visible;
  white-space: nowrap;
  + ${/* sc-selector */ Circle} {
    border-color: ${styles.Circle.borderColor};
  }
  &:focus {
    + ${/* sc-selector */ Circle} {
      border-color: ${(props) => props.theme.color.primary};
    }
  }
  &:checked {
    + ${/* sc-selector */ Circle} {
      border-color: ${(props) => props.theme.color.primary};
      &::before {
        content: '';
        width: ${(props) => props.theme.px(1)};
        height: ${(props) => props.theme.px(1)};
        border-radius: 50%;
        background-color: #344f79;
      }
    }
  }
`;

const RadioInput = (props) => {
  const { id, checked } = props;
  return (
    <Flex
      onClick={(e) => {
        props.onClicked(checked);
      }}
      alignItems="center"
      {...props}
    >
      <Label htmlFor={id} color={props.color}>
        <InputStyled id={id} type="radio" {...props} />
        <Circle />
        {props.label}
      </Label>
    </Flex>
  );
};

const SmsLogin = ({ history }) => {
  const [isActivating, setIsActivating] = useState(false);
  return (
    <Query query={ADVERTISE_SMS_LOGIN}>
      {({ data, loading }) => {
        if (loading || !data || data.getShouldAdvertiseSmsLogin === -1) return null;
        return (
          <CardBox mb={8}>
            <Flex flexDirection="column">
              <Box>
                <Heading textAlign="left" mb={4}>
                  One-time Code
                </Heading>
                <Text textAlign="left" mb={3}>
                  You can use a one-time code sent to your phone to authenticate.
                </Text>
                <Mutation refetchQueries={[{ query: ADVERTISE_SMS_LOGIN }]} awaitRefetchQueries={true} mutation={REJECT_SMS_LOGIN}>
                  {(mutate, { loading: loadingReject }) => (
                    <Flex style={{ alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                      {data.getShouldAdvertiseSmsLogin !== 2 && (
                        <Button onClick={mutate} disabled={loadingReject} variant={'outline'} style={{ maxWidth: '200px' }} width="200px">
                          Disable
                        </Button>
                      )}
                      {data.getShouldAdvertiseSmsLogin !== 1 && (
                        <Button disabled={loadingReject} variant={'primary'} onClick={() => setIsActivating(true)} width="200px">
                          Enable
                        </Button>
                      )}
                    </Flex>
                  )}
                </Mutation>
              </Box>
            </Flex>
            {isActivating && (
              <Modal
                isOpen={isActivating}
                onBackgroundClick={() => {
                  setIsActivating(false);
                }}
                onEscapeKeydown={() => {
                  setIsActivating(false);
                }}
              >
                {/* <SpecialModalBackground> */}
                <Box
                  style={{
                    margin: '0 auto',
                    alignSelf: 'center',
                    borderRadius: '20px',
                    position: 'relative',
                    backgroundColor: 'white',
                    padding: '24px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    width: '100vw',
                    maxWidth: '650px',
                  }}
                >
                  <ActivateSmsLoginFeature
                    onClose={() => setIsActivating(false)}
                    reject={() => {
                      setIsActivating(false);
                    }}
                  />
                </Box>
                {/* </SpecialModalBackground> */}
              </Modal>
            )}
          </CardBox>
        );
      }}
    </Query>
  );
};

export default withRouter(SmsLogin);
